import { render } from "./HomeFooter.vue?vue&type=template&id=fc8295ca&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=fc8295ca&lang=less&scoped=true"

import exportComponent from "C:\\project\\结构计算网\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8295ca"]])

export default __exports__